import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VideoPlayer.css';

export default function VideoPlayer({
  youtubeId,
  src,
  poster,
  title,
  subtitle,
}) {
  const { t } = useTranslation('common');
  const [active, setActive] = useState(false);
  const hasSource = youtubeId || src;
  const displayTitle = title ?? t('video.default_title');
  const displaySubtitle = subtitle ?? t('video.default_subtitle');

  return (
    <div className="vp">
      <div className={`vp-frame${active ? ' vp-frame--active' : ''}`}>

        {/* ── Poster / idle ── */}
        {!active && (
          <div
            className="vp-poster"
            style={poster ? { backgroundImage: `url(${poster})`, backgroundSize: 'cover', backgroundPosition: 'center' } : undefined}
          >
            <div className="vp-poster-grad" />

            {/* Decorative arcs */}
            <div className="vp-arc vp-arc-1" />
            <div className="vp-arc vp-arc-2" />

            {/* Logo watermark */}
            <img src="/logo-horizontal-white.png" alt="" width="700" height="280" className="vp-watermark" aria-hidden="true" />

            {/* Play button */}
            {hasSource ? (
              <button className="vp-play-btn" onClick={() => setActive(true)} aria-label={t('video.play_video')}>
                <span className="vp-play-pulse" />
                <span className="vp-play-circle">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28" style={{ paddingLeft: 3 }}>
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </span>
              </button>
            ) : (
              <div className="vp-soon">
                <span className="vp-soon-icon">🎬</span>
                <span>{t('video.coming_soon')}</span>
              </div>
            )}

            {/* Bottom info bar */}
            <div className="vp-overlay-info">
              <div className="vp-overlay-text">
                <div className="vp-overlay-title">{displayTitle}</div>
                <div className="vp-overlay-sub">{displaySubtitle}</div>
              </div>
              {hasSource && (
                <div className="vp-watch-badge">
                  <span>▶</span> {t('video.watch')}
                </div>
              )}
            </div>
          </div>
        )}

        {/* ── Active: YouTube embed ── */}
        {active && youtubeId && (
          <iframe
            className="vp-embed"
            src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1&color=white`}
            title={displayTitle}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        )}

        {/* ── Active: HTML5 video ── */}
        {active && src && !youtubeId && (
          <video
            className="vp-embed"
            src={src}
            poster={poster}
            controls
            autoPlay
          />
        )}
      </div>
    </div>
  );
}
